export const SiteWorkerHomePage = () => (
  <div className="flex max-w-2xl flex-col gap-8 px-6 py-8">
    <p className="text-lg text-foreground">
      Site work is completed in the SiteWorks app. This web portal is for
      Southern Water internal teams.
    </p>

    <section aria-label="Download the app" className="flex flex-col gap-3">
      <p className="text-muted-foreground">
        A download for the SiteWorks Android app will be coming soon.
      </p>
    </section>
  </div>
)
